import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import { GestureHandling } from "leaflet-gesture-handling"
import 'leaflet.markercluster'
import 'leaflet.fullscreen'
import * as Handlebars from 'handlebars';
import { addMapboxBaseLayers } from "../helpers/mapbox_base_layers"

const mediaPopupTemplate = `
  <div class="d-flex w-100 flex-column">
    <img src="{{media.url}}" style="width: 200px; object-fit: contain" class="rounded mb-1">
    <small class="text-muted">{{media.date}}</small>
    <small class="text-muted">{{media.lat}}, {{media.lng}}</small>
  </div>
`
const logLocationPopupTemplate = `
  <div class="d-flex w-100 flex-column">
    <span class="fw-bolder mb-1">Verified Location</span>
    <small class="text-muted">{{coordinates.latitude}}, {{coordinates.longitude}}</small>
  </div>
`

export default class extends Controller {
  static targets = ["container"]
  static values = { media: String, location: Object, geometry: String, gestureHandling: Boolean }

  connect() {
    this.showMap();
  };

  showMap() {
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
    var map = L.map(this.containerTarget, {
      gestureHandling: true,
      fullscreenControl: true,
      fullscreenControlOptions: { position: 'topleft' }
    });

    // `fullscreenchange` Event that's fired when entering or exiting fullscreen.
    map.on('fullscreenchange', function () {
      if (map.isFullscreen()) {
        map.gestureHandling.disable();
      } else {
        map.gestureHandling.enable();
      }
    });

    L.control.scale({'imperial': true, 'metric': false}).addTo(map);

    addMapboxBaseLayers(map);

    var bounds = [];

    try {
      if (!_.isEmpty(this.locationValue)) {
        console.log(`Location: ${this.locationValue}`);
        let coordinates = this.locationValue;
        let coordinateArray = [coordinates.latitude, coordinates.longitude];
        let locationMarker = L.marker(coordinateArray);
        locationMarker.addTo(map)
          .bindPopup(Handlebars.compile(logLocationPopupTemplate)({coordinates: coordinates}), {autoPan: true});
        bounds.push(coordinateArray);
      }
    } catch (error) {
      console.error(`Error: ${error}`);
    }

    if (!_.isEmpty(this.mediaValue)) {
      console.log(`Media: ${this.mediaValue}`);
      let jsonMedia = JSON.parse(this.mediaValue);

      var markers = L.markerClusterGroup({ maxClusterRadius: 50 });
      jsonMedia.forEach(function (media) {
        markers.addLayer(L.marker([media.lat, media.lng])
          .bindPopup(Handlebars.compile(mediaPopupTemplate)({media: media}), {autoPan: true}));
        bounds.push([media.lat, media.lng]);
      });
      map.addLayer(markers);
    }

    if (!_.isEmpty(this.geometryValue)) {
      //console.log(`Geometry: ${this.geometryValue}`);
      let jsonGeometry = JSON.parse(this.geometryValue);
      L.geoJSON(jsonGeometry).addTo(map);
      bounds.push(L.geoJSON(jsonGeometry).getBounds());
    }

    if (bounds.length > 0) {
      //console.log(`Bounds: ${bounds}`);
      map.fitBounds(bounds);
    }
  };
}

// <div data-controller="map" data-map-target="container" data-map-zoom-value="5" data-map-center-lat="39.8283" data-map-center-lng="-98.5795" data-map-id="trails-map" class="map mb-3" style="height: 500px;"></div>

